<div class="bg-white w-full md:w-1/2 py-2 rounded-2xl h-full">
  <ul class="block my-4 list-none">
    <li class="flex align-center flex-col">
      <div (click)="openNotification()" class="cursor-pointer flex gap-5 px-5 items-center">
        <div class="flex flex-initial rounded-full py-4 px-5" [ngClass]="isOpen ? 'bg-primary' : 'bg-gray-200'">
          <onafriq-icon [icon]="notification?.icon!" [size]="'sm'" [color]="'gray-700'"></onafriq-icon>
        </div>
        <div class="flex flex-col flex-1">
          <onafriq-heading [level]="4" class="text-gray-800" [text]="notification.notificationType"></onafriq-heading>
          <div class="flex-row">
            <span
              *ngIf="mainStatusChange"
              [ngClass]="{
                'text-green-500': isOpen ? status === '1' : notification?.notificationStatus === 'Active',
                'text-red-500': isOpen ? status === '2' : notification?.notificationStatus === 'InActive',
              }"
              class="font-medium text-xs"
              >Status:
              {{
                isOpen ? (status === '1' ? 'On' : 'Off') : notification?.notificationStatus === 'Active' ? 'On' : 'Off'
              }}</span
            >
            <span *ngIf="!mainStatusChange" class="font-medium text-xs text-red-500">Status: Off</span>
            <span *ngIf="notification.notificationId === '2'" class="text-gray-600 text-xs"
              ><span class="mx-1">|</span>{{ isOpen ? defaultFreq : 'Daily' }}</span
            >
            <span class="text-gray-600 text-xs"><span class="mx-1">|</span>Email</span>
          </div>
        </div>
        <div class="flex flex-initial">
          <onafriq-icon
            [icon]="isOpen ? 'chevron-up' : 'chevron-down'"
            [size]="'sm'"
            [color]="'gray-500'"></onafriq-icon>
        </div>
      </div>
      <div
        [ngClass]="isOpen ? 'h-[240px]' : '!my-0 h-0 !p-0'"
        class="ml-25 mr-auto mt-3 w-1/2 transition-all duration-300 ease-in-out overflow-y-auto overflow-x-hidden">
        <div>
          <div class="mb-5">
            <onafriq-heading [level]="6" [text]="'Status'"></onafriq-heading>
            <hr class="border-gray-200 mt-1 mb-3" />
            <span class="flex text-gray-600 text-xs items-center">
              {{ status === '1' ? 'On' : 'Off' }}
              <app-custom-toggle
                class="ml-3"
                [on]="status === '1'"
                (onChange)="emitToggleSwitch($event, notification.notificationId)"></app-custom-toggle>
            </span>
          </div>
          <div *ngIf="notification.notificationId === '3'">
            <label class="innerHeader"> Threshold</label><br />
            <div class="innerDivider"></div>
            <div class="flex items-center gap-2">
              <input
                type="text"
                placeholder="Threshold"
                name="threshold"
                class="pl-2 thresholdbox"
                [(ngModel)]="threshold"
                (focusout)="updateNotificationLowBal()"
                autocomplete="off" />
              <span id="currency"> {{ thresholdCurrency }}</span>
            </div>
          </div>
          <div class="mb-5 flex flex-col" *ngIf="notification.notificationId === '2'">
            <onafriq-heading [level]="6" [text]="'Frequency'"></onafriq-heading>
            <hr class="border-gray-200 mt-1 mb-3" />
            <onafriq-dropdown
              [disabled]="false"
              [dropdownMenu]="[
                {
                  label: 'Daily',
                  value: 1,
                  preSelected: true
                }
              ]"
              [placeholder]="'Filter'"
              class="w-50"
              [isMultiSelect]="false"
              [hasSearch]="false"></onafriq-dropdown>
          </div>
          <div class="mb-5">
            <onafriq-heading [level]="6" [text]="'Channel'"></onafriq-heading>
            <hr class="border-gray-200 mt-1 mb-3" />
            <div class="flex items-center mb-3">
              <onafriq-checkbox [checked]="true" [disabled]="true"></onafriq-checkbox>
              <span class="text-gray-800 text-xs ml-4">Email</span>
            </div>
          </div>
          <div class="mb-5" *ngIf="actor === 'admin' && notification?.notificationId == '5'">
            <onafriq-heading [level]="6" [text]="'Add CC Email Ids'"></onafriq-heading>
            <hr class="border-gray-200 mt-1 mb-3" />
            <onafriq-textarea
              class="w-[500px] pl-1"
              [inputModel]="ccMailId"
              (inputModelChange)="onCcChange($event)"
              [placeholder]="'Enter emails separated by commas'" />
            <onafriq-button
              class="flex justify-center mr-1"
              [label]="'Save'"
              [type]="'primary'"
              (onClick)="updatePredictiveNotification()"
            />
              
            <span *ngIf="ccError" class="text-red-500 text-xs mt-1 block">{{ ccError }}</span>
          </div>
        </div>
      </div>
    </li>
  </ul>
</div>
